import { createSlice } from "@reduxjs/toolkit";
import { ITrainingMatricsSlice } from "../../../models/staff";


const initialTrainingMatricsState: ITrainingMatricsSlice = {
    trainingMatrics: undefined,
};

const trainingMatricsSlice = createSlice({
  name: "trainingMatricsDetails",
  initialState: initialTrainingMatricsState,
  reducers: {
    setTrainingMatrics: (state, action: { payload: any }) => {
      state.trainingMatrics = action.payload;
    },
  },
});

export const { setTrainingMatrics } = trainingMatricsSlice.actions;

const trainingMatricsReducer = trainingMatricsSlice.reducer;

export type trainingMatricsDetailsState = ReturnType<typeof trainingMatricsReducer>;

export default trainingMatricsReducer;